'use strict';

var cjs = {};

exports.__exports = cjs;
//# sourceMappingURL=index.cjs.map
